import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { LogoMark } from "@/components/site/LogoMark";

const links = [
  { label: "Services", href: "#services", testId: "nav-link-services" },
  { label: "About", href: "#about", testId: "nav-link-about" },
  { label: "Contact", href: "#contact", testId: "nav-link-contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/70 backdrop-blur-xl border-b border-gray-200/50 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
        <div className="flex h-24 items-center justify-between">
          <a href="#top" data-testid="nav-logo" className="flex items-center gap-3.5 group">
            <span className="transition-transform duration-300 group-hover:-translate-y-0.5">
              <LogoMark size={48} />
            </span>
            <span className="font-heading text-2xl md:text-3xl font-extrabold tracking-tight text-[#0A0A0A] leading-none">
              Rae Cloud
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-10">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={l.testId}
                className="text-sm font-medium text-[#52525B] hover:text-[#0A0A0A] transition-colors relative after:absolute after:-bottom-1.5 after:left-0 after:h-[2px] after:w-0 after:bg-[#0047AB] hover:after:w-full after:transition-all after:duration-300"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              data-testid="nav-cta-button"
              className="bg-[#0047AB] hover:bg-[#003380] text-white text-sm font-medium px-6 py-3 rounded-none transition-colors"
            >
              Let's Talk
            </a>
          </nav>

          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="md:hidden text-[#0A0A0A]"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-white border-b border-gray-200 px-6 py-6 space-y-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-base font-medium text-[#0A0A0A]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="block bg-[#0047AB] text-white text-center font-medium px-6 py-3"
          >
            Let's Talk
          </a>
        </div>
      )}
    </header>
  );
};
